/** 102 × 76 mm label at 203 dpi (812 × 609 dots). */
export const LABEL_102X76_203DPI = {
  id: "102x76" as const,
  widthIn: 4,
  heightIn: 3,
  dpi: 203,
  widthDots: 812,
  heightDots: 609,
  margin: 16,
  label: "102 × 76 mm",
  recommendedUse: "Large parts and passports",
} as const;
